


import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { expand } from 'rxjs/operators';

@Pipe({
  name: 'toLocalDate'
})

export class ToLocalDatePipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  /**
   * @param value The date expression: a `Date` object,  a number
   * (milliseconds since UTC epoch), or an ISO string (https://www.w3.org/TR/NOTE-datetime).
   * @param format The date/time components to include, using predefined options or a
   * custom format string.
   * @param timezone A timezone offset (such as `'+0430'`), or a standard
   * UTC/GMT or continental US timezone abbreviation.
   * When not supplied, uses the end-user's local system timezone.
   * @param locale A locale code for the locale format rules to use.
   * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
   * See [Setting your app locale](guide/i18n#setting-up-the-locale-of-your-app).
   * @returns A date string in the desired format.
   */
  //  (value: any, ...args: any[]): any
  // transform(value: number, ...args: any[]): string | null {

  // };


  // transform(value: any, format?: string, timezone?: string, locale?: string): string | null{
  transform(value: any, ...args: any[]): string | null {

    let format, timezone, locale = null;
    if (args.length > 0) {
      format = args[0]
    }
    if (args.length > 1) {
      // timezone=args[1]
    }
    if (args.length > 2) {
      locale = args[2]
    }
    let date = new Date(value);
    var milliseconds = date.getTime();
    var offets = -1 * date.getTimezoneOffset() * 60 * 1000;
    let date2 = new Date(milliseconds + offets);
    return this.datePipe.transform(date2, format, timezone, locale);
  }
}
